export const frontmatter = {
    "draft": true,
    "title": "Attention groups",
    "sidebar_group": "reference",
    "sidebar_label": "Attention groups",
    "sidebar_order": 8
}

export const toc = []